import ExpertKnowledge from "./views/ExpertKnowledge.vue";
import FragmentEditor from "./views/FragmentEditor.vue";

const moduleRoutes = [
	{
		path: "/:domainId/expert-knowledge",
		name: "Expert Knowledge",
		component: ExpertKnowledge,
	},
	{
		path: "/:domainId/expert-knowledge/:fragmentId",
		name: "Knowledge Fragment Editor",
		component: FragmentEditor,
	},
];

export default moduleRoutes;
